<template>
    <div>
        <div v-show="!hideRegions">
            <div v-if="!hideFieldLabels" class="ap-modal-input-name">
                Регион
            </div>
            <JHCustomSelect v-model="inputRegionName"
                            :selectOptions="optionsRegions"
                            :selectName="(region, key) => region.title_ru"
                            :selectableParamCondition="(region, key) => region.region_id"
                            :selectedParamValue="selectedParamValueRegion"
                            @selected="selectRegion"
                            :visibleMessageLoading="waitingResponseToRegionRequest"
            />
        </div>
        <div v-if="!hideFieldLabels" class="ap-modal-input-name">
            Город
        </div>
        <JHCustomSelect v-model="inputCityName"
                        :selectOptions="optionsCities"
                        :selectName="(city, key) => city.title_ru"
                        :selectDescription="(city, key) => city.region_ru"
                        :selectableParamCondition="(city, key) => city.city_id"
                        :selectedParamValue="selectedParamValueCity"
                        @selected="selectCity"
                        @selectedName="selectName"
                        @scrollReachEnd="scrollReachEndCities"
                        @focusOnInput="updateCities"
                        :visibleMessageLoading="waitingResponseToCityRequest"
        />
    </div>
</template>

<script>
import JHCustomSelect from "../../TemplatesLibrary/JHCustomSelect";
export default {
name: "SelectRegionCity",
    components: {JHCustomSelect},
    data() {
        return {
            cityTimerId: null,
            regionTimerId: null,
        }
    },
    props: {
        hideRegions: {
            type: Boolean,
            default: false
        },
        hideFieldLabels: {
            type: Boolean,
            default: false
        },
        selectedRegionID: null,
        selectedCityID: null,
    },
    computed: {
        inputCityName: {
            get() {
                return this.$store.state.adminPanel.selectRegionCity.cities.mask;
            },
            set(value) {
                this.$store.commit('adminPanel/selectRegionCity/cities/MASK', value);
                if (this.cityTimerId) {
                    clearTimeout(this.cityTimerId);
                    this.cityTimerId = null;
                }
                this.cityTimerId = setTimeout(() => {
                    this.$store.commit('adminPanel/selectRegionCity/cities/CLEAR_CITIES');
                    this.$store.dispatch('adminPanel/selectRegionCity/GET_CITIES_BY_SELECT_CATEGORIES');
                    this.cityTimerId = null;
                }, 500);
            }
        },
        inputRegionName: {
            get() {
                return this.$store.state.adminPanel.selectRegionCity.regions.mask;
            },
            set(value) {
                this.$store.commit('adminPanel/selectRegionCity/regions/MASK', value);
            }
        },

        selectedParamValueCity: {
            get() {
                if(this.selectedCityID !== undefined){
                    return this.selectedCityID;
                } else {
                    return this.$store.state.adminPanel.selectRegionCity.selectedCityID;
                }
            },
            set(value) {
                this.$store.dispatch('adminPanel/selectRegionCity/SELECTED_CITY', value);
            }
        },
        selectedParamValueRegion: {
            get() {
                if(this.selectedRegionID !== undefined){
                    return this.selectedRegionID;
                } else {
                    return this.$store.state.adminPanel.selectRegionCity.selectedRegionID;
                }
            },
            set(value) {
                this.$store.commit('adminPanel/selectRegionCity/SELECTED_REGION_ID', value);
            }
        },

        waitingResponseToCityRequest() {
            return this.$store.state.adminPanel.selectRegionCity.cities.waitingResponseToCityRequest;
        },
        waitingResponseToRegionRequest() {
            return this.$store.state.adminPanel.selectRegionCity.regions.waitingResponseToRegionRequest;
        },

        optionsCities() {
            return this.$store.getters["adminPanel/selectRegionCity/cities/SELF"];
        },
        optionsRegions() {
            return this.$store.getters["adminPanel/selectRegionCity/regions/SELF"];
        },
    },
    watch: {
        selectedCityID() {
            this.$store.dispatch('adminPanel/selectRegionCity/SELECTED_CITY', this.selectedParamValueCity);
        }
    },
    methods:{
        selectName(name) {
            this.$emit('citySelectedName', name);
        },
        updateCities(status) {
            if(status) {
                this.$store.commit('adminPanel/selectRegionCity/cities/CLEAR_CITIES', '');
                this.$store.dispatch('adminPanel/selectRegionCity/GET_CITIES_BY_SELECT_CATEGORIES');
            }
        },
        scrollReachEndCities() {
            if (this.optionsCities.length !== 0)
                this.$store.dispatch('adminPanel/selectRegionCity/GET_CITIES_BY_SELECT_CATEGORIES');
        },
        selectCity(selectedParam) {
            this.$store.commit('adminPanel/selectRegionCity/cities/MASK', '');
            this.selectedParamValueCity = selectedParam;
            this.$emit('citySelected', selectedParam);
        },
        selectRegion(selectedParam) {
            this.$store.commit('adminPanel/selectRegionCity/regions/MASK', '');
            this.selectedParamValueRegion = selectedParam;
            this.$emit('regionSelected', selectedParam);
        },
    },
    async mounted() {
        await this.$store.dispatch('adminPanel/selectRegionCity/regions/GET_REGIONS');
    },
    destroyed() {
        this.$store.dispatch('adminPanel/selectRegionCity/CLEAR_ALL');
    }
}
</script>

<style scoped>

</style>
